function LoadingMessage(props) {
  return (
    <div className="loading">
      <h1>Cargando...</h1>
    </div>
  );
}

export default LoadingMessage;
